import React, { useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const RECAPTCHA_SITE_KEY = "6LdzjZMrAAAAAIgA8g-d22oQqDAQS8hqBZ28rFgA";

export const ContactFormWithCaptcha_TEST = () => {
  const recaptchaRef = useRef<ReCAPTCHA>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const token = await recaptchaRef.current?.executeAsync();
    recaptchaRef.current?.reset();

    const res = await fetch('https://wi8zkeven2.execute-api.us-east-1.amazonaws.com/prod/feedback', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token })
    });

    const result = await res.json();
    alert(result.success ? 'Verified!' : 'Failed!');
  };

  return (
    <form onSubmit={handleSubmit}>
      <input type="text" name="message" placeholder="Your message" required />
      <ReCAPTCHA
        ref={recaptchaRef}
        sitekey={RECAPTCHA_SITE_KEY}
        size="invisible"
      />
      <button type="submit">Submit</button>
    </form>
  );
};
